/*eslint-disable*/
import React, { useState, useEffect, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import { language, STYLES } from "config";
import { makeStyles } from "@material-ui/core/styles";
import AlertDialog from "../../../components/AlertDialog";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Label,
  FormGroup,
  Input,
  Row,
  Col,
  FormText,
  Container,
  // Alert,
} from "reactstrap";
import FlatList from "flatlist-react";
import CustomDropDownPicker from "components/CustomDropDownPicker";
import { FirebaseContext } from "common";
import { useLocation, useNavigate } from "react-router-dom";
const useStyles = makeStyles({
  root: {
    minWidth: 275,
    // border: "5px solid",
    // borderColor: STYLES.PRIMARY_APP_CLR,
    // borderBlockStartColor: STYLES.TERTIARY_APP_CLR,
    // borderBlockStart: "2px solid",
    // background: 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
    flexDirection: "column",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "100%",
  },
  Button: {
    width: 150,
    height: 40,
  },
  ImgContainer: {
    borderRadius: '50',
    height: "75%",
    width: "100%",
    aspectRatio: '16/9',
  },
  Card: {
    width: "70%",
    padding: 10,
    minWidth: 275,
    border: "1px solid",
    borderColor: STYLES.PRIMARY_APP_CLR,
    borderRadius: 30,
  },
  ImgCard: {
    width: "90%",
    border: "1px solid",
    borderColor: STYLES.PRIMARY_APP_CLR,
    borderRadius: 30,
  },
  PriceText: { margin: "20px0 15px", color: STYLES.TERTIARY_APP_CLR, fontSize: 32 },
  propType: {
    margin: "20px0 15px",
    fontSize: 16,
    color: "grey"
  },
  detialsSmokey: { width: "100%", alignContent: "center", flexDirection: 'row', height: 'auto', backgroundColor: "#dcdcdc", display: "flex", flexDirection: "row" },
  detials: { width: "100%", alignContent: "center", flexDirection: 'row', height: 'auto', display: "flex", flexDirection: "row" },
  CardHeader: {
    flexDirection: "column",
    fontSize: 18,
    fontWeight: "400",
    color: STYLES.TERTIARY_APP_CLR,
    display: "flex",
    margin: 15
  },
  separator: {
    height: 1,
    width: "100%",
    backgroundColor: STYLES.TERTIARY_APP_CLR,
    alignSelf: "center",
    marginBottom: 15,
  },
  InfoDescriptionText: {
    width: "50%",
    color: STYLES.WEB_APP_FONT_CLR,
    flexDirection: "row",
    fontSize: 15,
    fontWeight: "700"
    , marginBottom: 0

  },
  InfoText: {
    color: STYLES.WEB_APP_FONT_CLR,
    flexDirection: "row",
    fontSize: 15,
    fontWeight: "300"
    , marginBottom: 0
  },
  radioText: {
    width: "30%",
    color: STYLES.WEB_APP_FONT_CLR,
    flexDirection: "row",
    fontSize: 15,
    fontWeight: "700"
    , marginBottom: 0

  },
  separatorTwo: {
    height: 1,
    width: "100%",
    backgroundColor: STYLES.TERTIARY_APP_CLR,
    alignSelf: "center",
    marginBottom: 5,
  },
  CardHeaderTwo: {
    flexDirection: "column",
    fontSize: 18,
    fontWeight: "400",
    color: STYLES.TERTIARY_APP_CLR,
    display: "flex",
    margin: 15
  },
});

const StaffPullForward = () => {
  const { api } = useContext(FirebaseContext);
  const { UpdateEnquiry, fetchCurrentAdminsBranchEnquiries } = api;
  ////////////////////////////////////////////////////////////////////
  //Redux
  const dispatch = useDispatch();
  const styles = useStyles();
  const auth = useSelector((state) => state.auth);
  const brokers = useSelector((state) => state.brokers.users);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.state?.item?.pullforward?.pullforwardDate !== undefined) {
      setPullForwardUpdateDetails(location.state?.item)
    } else {
      setdetails(location.state.item);
      console.log("details", location.state.item);
    }
  }, []);

  useEffect(() => {
    let arr = [];
    if (brokers) {
      for (let index = 0; index < brokers.length; index++) {
        const element = brokers[index];

        // Populate the list with all brokers, remove brokerHomeOffice filter
        if (element.brokerHomeOffice === auth?.info?.profile?.adminHomeOffice) {
          arr.push({
            value: element.id, // The broker ID (or name if preferred)
            label: `${element.firstName} ${element.lastName}`, // Broker name
          });
        }
      }
      setBrokerList(arr.sort((a, b) => a.label.localeCompare(b.label)));
    }
  }, [brokers]);

  ////////////////////constant////////////////////
  const [details, setdetails] = useState([]);
  const [brokerList, setBrokerList] = useState([]);
  const [pullForwardUpdateDetails, setPullForwardUpdateDetails] = useState();
  //for all and for broker state
  const [pullForwardType, setPullForwardType] = useState({
    forAll: pullForwardUpdateDetails?.pullforward?.pullforwardType ? true : false,
    forBroker: !pullForwardUpdateDetails?.pullforward?.pullforwardType ? true : false,
  });
  // UpdateEnquiry
  const [state, setState] = useState({
    pullforward: pullForwardUpdateDetails ? pullForwardUpdateDetails.pullforward?.pullforward : false,
    pullforwardNote: pullForwardUpdateDetails ? pullForwardUpdateDetails.pullforward?.pullforwardNote : "",
    pullforwardDate: pullForwardUpdateDetails ? pullForwardUpdateDetails.pullforward?.pullforwardDate : false,
    shareBrokers: pullForwardUpdateDetails ? pullForwardUpdateDetails.pullforward?.shareBrokers : [],
  });

  const pullForward = () => {
    if (!pullForwardType.forAll && !pullForwardType.forBroker) {
      alert(`Please select For All or For Broker option to proceed`)
      return;
    }

    if (pullForwardType.forAll === true) {
      if (state?.pullforwardDate) {
        console.log(`in for all`)
        let pull = {
          ...details,
          pullforward: {
            pullforward: state.pullforward,
            pullforwardNote: state.pullforwardNote,
            pullforwardDate: new Date(state.pullforwardDate).getTime(),
            pullforwardType: "For All",
            shareBrokers: [],
          },
          status: "PullForward",
        };
        try {
          dispatch(UpdateEnquiry(pull));
          dispatch(fetchCurrentAdminsBranchEnquiries());
          alert(`Pull forward created successfully`)
          navigate(-1);
        } catch (error) {
          console.log(error.message);
        }
      }
    }

    if (pullForwardType.forBroker === true) {
      if (state?.pullforwardDate) {
        console.log(`in for broker`)
        let pull = {
          ...details,
          pullforward: {
            pullforward: state.pullforward,
            pullforwardNote: state.pullforwardNote,
            pullforwardDate: new Date(state.pullforwardDate).getTime(),
            shareBrokers: state.shareBrokers,
          },
          status: "Active",
        };
        try {
          dispatch(UpdateEnquiry(pull));
          dispatch(fetchCurrentAdminsBranchEnquiries());
          alert(`Pull forward created successfully`)
          navigate(-1);
        } catch (error) {
          console.log(error.message);
        }
      }
    }

  }

  const renderEnquiryData = () => {
    return (
      <>
        <div className={styles.root}>
          <Card className={styles.Card}>
            <CardTitle className={styles.CardHeader}>
              Property Details
              <div className={styles.separator} />
            </CardTitle>
            <CardBody style={{ margin: 20 }}>
              <FormGroup>
                <div className={styles.detials}>
                  <p className={styles.InfoDescriptionText}>Address</p>

                  <p className={styles.InfoText}>{details?.address?.suburb}</p>
                </div>
                <div className={styles.detialsSmokey}>
                  <p className={styles.InfoDescriptionText}>Property Size</p>

                  <p className={styles.InfoText}>Min: {details?.sizeMin ? details?.sizeMin : details?.sizeRangeMin}㎡ Max: {details?.sizeMax ? details?.sizeMax : details?.sizeRangeMax}㎡</p>
                </div>
                <div className={styles.detials}>
                  <p className={styles.InfoDescriptionText}>Type of Property</p>

                  <p className={styles.InfoText}>{details?.typeOfProperty}</p>
                </div>
                <div className={styles.detialsSmokey}>
                  <p className={styles.InfoDescriptionText}>Notes</p>

                  <p className={styles.InfoText}>{details?.additionalNotes ? details?.additionalNotes : details?.notes}</p>
                </div>
                <div className={styles.detials}>
                  <p className={styles.InfoDescriptionText}>Enquiry id</p>

                  <p className={styles.InfoText}>{details?.id}</p>
                </div>
              </FormGroup>
            </CardBody>
          </Card>
          <Card className={styles.Card}>
            <CardTitle className={styles.CardHeaderTwo}>
              Pull Forward
              <div className={styles.separatorTwo} />
            </CardTitle>
            <CardBody>
              <FormGroup>
                <Label
                  check
                  className={styles.radioText}
                  style={{
                    color: "#0b042e",
                    // marginTop: 45,
                    // margin: "10px 0 0 1px",
                  }}
                >
                  <Input
                    type="radio"
                    name="radio2"
                    style={{
                      marginLeft: 25,
                      borderColor: "#009ad8",
                      borderWidth: 2,
                      height: 25,
                      width: 25,
                      marginTop: -4,
                      marginRight: 5,
                    }}
                    value={pullForwardType.forAll}
                    onChange={() => {
                      setPullForwardType({
                        ...pullForwardType,
                        forAll: true,
                        forBroker: false,
                        shareBrokers: [],
                      });
                    }}
                  />
                  For All
                </Label>
                <Label
                  check
                  className={styles.radioText}
                  style={{
                    color: "#0b042e",
                    // marginTop: 45,
                    // margin: "10px 0 0 1px",
                  }}
                >
                  <Input
                    type="radio"
                    name="radio2"
                    style={{
                      marginLeft: 25,
                      borderColor: "#009ad8",
                      borderWidth: 2,
                      height: 25,
                      width: 25,
                      marginTop: -4,
                      marginRight: 5,
                    }}
                    value={pullForwardType.forBroker}
                    onChange={() => {
                      setPullForwardType({
                        ...pullForwardType,
                        forAll: false,
                        forBroker: true,
                      });
                    }}
                  />
                  For a Broker
                </Label>
              </FormGroup>
              <FormGroup>
                <Label
                  check
                  className={styles.radioText}
                  style={{
                    color: "#0b042e",
                    // marginTop: 45,
                    // margin: "10px 0 0 1px",
                  }}
                >
                  <Input
                    type="radio"
                    name="radio1"
                    style={{
                      marginLeft: 25,
                      borderColor: "#009ad8",
                      borderWidth: 2,
                      height: 25,
                      width: 25,
                      marginTop: -4,
                      marginRight: 5,
                    }}
                    value={state.pullforward}
                    onChange={() => {
                      setState({
                        ...state,
                        pullforward: "Renew Lease",
                      });
                    }}
                  />
                  Renew Lease
                </Label>
                <Label
                  check
                  className={styles.radioText}
                  style={{
                    color: "#0b042e",
                    // marginTop: 45,
                    // margin: "10px 0 0 1px",
                  }}
                >
                  <Input
                    type="radio"
                    name="radio1"
                    style={{
                      marginLeft: 25,
                      borderColor: "#009ad8",
                      borderWidth: 2,
                      height: 25,
                      width: 25,
                      marginTop: -4,
                      marginRight: 5,
                    }}
                    value={state.pullforward}
                    onChange={() => {
                      setState({
                        ...state,
                        pullforward: "Not Looking",
                      });
                    }}
                  />
                  Not Looking
                </Label>
                <Label
                  check
                  className={styles.radioText}
                  style={{
                    color: "#0b042e",
                    // marginTop: 45,
                    // margin: "10px 0 0 1px",
                  }}
                >
                  <Input
                    type="radio"
                    name="radio1"
                    style={{
                      marginLeft: 25,
                      borderColor: "#009ad8",
                      borderWidth: 2,
                      height: 25,
                      width: 25,
                      marginTop: -4,
                      marginRight: 5,
                    }}
                    value={state.pullforward}
                    onChange={() => {
                      setState({
                        ...state,
                        pullforward: "Other",
                      });
                    }}
                  />
                  Other
                </Label>
              </FormGroup>

              {pullForwardType.forBroker ? (
                <FormGroup>
                  <CustomDropDownPicker
                    borderColor="#399ddb"
                    options={brokerList}
                    isMulti={true}
                    onChange={(selectedBrokers) => {
                      setState({ ...state, shareBrokers: selectedBrokers })
                    }}
                    placeholder="Select Brokers"
                    value={state.shareBrokers}
                  />
                </FormGroup>
              ) : null}

              <FormGroup>
                <Input
                  type="date"
                  fullWidth
                  // bsSize="lg"
                  value={state?.pullforwardDate}
                  onChange={(event) => {
                    console.log(`Target date: ${event.target.value}`);
                    setState({
                      ...state,
                      pullforwardDate: event.target.value,
                    });
                  }}
                  style={{
                    fontSize: 15,
                    fontWeight: "400",
                    border: "1px solid",
                    borderColor: "#399ddb",
                    color: "#0b042e",
                    marginBottom: 5,
                  }}
                  customLabelStyles={{
                    colorFocused: "red",
                    colorBlurred: "black",
                    fontSizeFocused: 12,
                  }}
                />
                <Input
                  type="text"
                  fullWidth
                  // bsSize="lg"
                  placeholder="Pull forward note"
                  value={state.pullforwardNote}
                  onChange={(event) => {
                    setState({
                      ...state,
                      pullforwardNote: event.target.value,
                    });
                  }}
                  style={{
                    fontSize: 15,
                    fontWeight: "400",
                    border: "1px solid",
                    borderColor: "#399ddb",
                    color: "#0b042e",
                  }}
                  customLabelStyles={{
                    colorFocused: "red",
                    colorBlurred: "black",
                    fontSizeFocused: 12,
                  }}
                />
                <div
                  style={{
                    alignSelf: "center",
                    marginTop: 10,
                  }}
                >
                  <Button
                    style={{
                      fontSize: 15,
                      fontWeight: "400",
                      backgroundColor: "#0b042e",
                    }}
                    onClick={() => {
                      pullForward();
                    }}
                  >
                    Pull Forward
                  </Button>
                </div>
              </FormGroup>
            </CardBody>
          </Card>
        </div>
      </>
    );
  };
  return <>{renderEnquiryData()}</>;
};

export default StaffPullForward;
